// import React from "react";
import ContactUi from "./ContactUi";

export default function ContactUs() {
  return (
    <section className="">
      <ContactUi />
    </section>
  );
}
// This is a simple landing page component for a React application.
